export function formatDateDisplayString(dateString: string | undefined | null): string {
  if (!dateString) {
    return ""
  }
  const date = new Date(Date.parse(dateString))
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
  const day = String(date.getDate()).padStart(2, '0');
  return `${day}/${month}/${year}`;
}

export function formatDateTimeDisplayString(dateString: string | undefined | null): string {
  if (!dateString) {
    return ""
  }
  const date = new Date(dateString);
  return `${formatDateDisplayString(dateString)} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
}

export function formatString(dateString: string | undefined | null): string | null {
  if (!dateString) {
    return null
  }
  const date = new Date(Date.parse(dateString))
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatDate(date: Date): string {
  if (!date) {
    return ""
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatDisplayDate(date: Date): string {
  if (!date) {
    return ""
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
  const day = String(date.getDate()).padStart(2, '0');
  return `${day} ${month} ${year}`;
}

export function formatCurrenty(value: number): string {
  return value.toFixed(2);
}
